var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      {
        staticClass: "flex-aligncol-center",
        staticStyle: { "margin-top": "150px" },
      },
      [
        _c("img", {
          staticClass: "topic-icon",
          attrs: { src: require("@/assets/topicIcon.png") },
        }),
        _c(
          "div",
          {
            staticClass: "title-1",
            staticStyle: { "font-size": "22px", padding: "20px 0 30px 0" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.queryRecord?.name || "请选择测评") +
                "\n    "
            ),
          ]
        ),
        _c("div", [
          _c("span", { staticClass: "tip" }, [
            _vm._v("共" + _vm._s(_vm.baseInfo?.allNum || 0) + "个测评"),
          ]),
          _c("span", { staticClass: "tip" }, [
            _vm._v("题数：" + _vm._s(_vm.baseInfo?.allTopicNum || 0) + "题"),
          ]),
          _c("span", { staticClass: "tip" }, [
            _vm._v("预计用时：" + _vm._s(_vm.baseInfo?.allTime || 0) + "分钟"),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "flex-align-center",
            staticStyle: { padding: "20px 0" },
          },
          [
            _c("a-select", {
              staticClass: "selet-stu",
              attrs: {
                "show-search": "",
                "option-filter-prop": "children",
                "filter-option": _vm.filterOption,
                placeholder: "请选择测评",
                options: _vm.evaluationList,
              },
              on: { select: _vm.selectEvalInfo },
              model: {
                value: _vm.formData.evalId,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "evalId", $$v)
                },
                expression: "formData.evalId",
              },
            }),
            _vm.isShowCom
              ? _c("j-dict-select-tag", {
                  staticClass: "selet-stu",
                  attrs: {
                    placeholder: "请选择年级",
                    dictCode:
                      "school_grade,grade_name,id,0=delete_flag order by sort_order",
                    optionalVals: _vm.queryRecord.gradeIds,
                    disabled: !_vm.formData.evalId,
                    isShowEmpty: false,
                  },
                  on: {
                    setDefaultValue: _vm.setDefaultGrade,
                    select: (record) => _vm.selectStuInfo("grade", record),
                  },
                  model: {
                    value: _vm.formData.gradeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "gradeId", $$v)
                    },
                    expression: "formData.gradeId",
                  },
                })
              : _vm._e(),
            _c("j-dict-select-tag", {
              staticClass: "selet-stu",
              attrs: {
                placeholder: "请选择班级",
                dictCode:
                  "school_class,name,id,grade_id=" +
                  (!_vm.formData.gradeId ? -1 : _vm.formData.gradeId),
                async: true,
                disabled: !_vm.formData.gradeId,
                isShowEmpty: false,
              },
              on: { select: (record) => _vm.selectStuInfo("class", record) },
              model: {
                value: _vm.formData.classId,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "classId", $$v)
                },
                expression: "formData.classId",
              },
            }),
            _c("a-select", {
              staticClass: "selet-stu",
              attrs: {
                "show-search": "",
                "option-filter-prop": "children",
                "filter-option": _vm.filterOption,
                placeholder: "请选择学生",
                disabled: !_vm.formData.classId,
                options: _vm.classStuList,
              },
              on: { change: _vm.changeStuInfo },
              model: {
                value: _vm.formData.studentId,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "studentId", $$v)
                },
                expression: "formData.studentId",
              },
            }),
          ],
          1
        ),
        _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
          _vm.currSelectStu.pic
            ? _c("img", {
                staticClass: "stu-pic",
                attrs: { src: _vm.currSelectStu.pic, alt: "学生图片" },
              })
            : _vm._e(),
        ]),
        _c(
          "a-button",
          {
            staticStyle: { width: "260px", height: "36px" },
            attrs: { type: "primary" },
            on: { click: _vm.submitStuInfo },
          },
          [_vm._v("\n      开始答题\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }